// @ts-ignore
export const all = (state) => state.all;

// @ts-ignore
export const one = (state) => state.one;

// @ts-ignore
export const stats = (state) => state.stats;

// @ts-ignore
export const generatedExternal = (state) => state.generatedExternal;
